import { EField } from "./schema.updateGroup.types";
export var getInitialValues = function (extraData) {
    var _a;
    var group = extraData.group;
    return _a = {},
        _a[EField.Name] = group.name,
        _a[EField.SortWeight] = group.sortWeight,
        _a;
};
